<template>
	<VModal ref="conflict-saving" title="Conflict saving">
		<p>
			Conflict saving, please save the right side and update when you can update
			again
		</p>
		<div class="flex gap-4">
			<div class="flex-1">
				<TextArea
					v-model="task_body_my_m"
					:rows="4"
					:placeholder="'Task body origin'"
				/>
				<div class="text-center">
					<VButton @click.prevent="saveMyVersion">
						Save My
					</VButton>
				</div>
			</div>
			<div class="flex-1">
				<TextArea
					v-model="task_body_theirs_m"
					:rows="4"
					:placeholder="'Task body new'"
				/>
				<div class="text-center">
					<VButton @click.prevent="$reds['conflict-saving'].hide()">
						Save Theirs
					</VButton>
				</div>
			</div>
		</div>
	</VModal>
</template>

<script>
import VModal from "@/components/atoms/VModal.vue";
import TextArea from "@/components/atoms/TextArea.vue";
import VButton from "@/components/atoms/VButton.vue";

export default {
	name: 'ConflictSavingModal',
	components: {
		VModal,
		TextArea,
		VButton
	},
	props: ['task_body_my', 'task_body_theirs'],
	data() {
		return {
			task_body_my_m: this.task_body_my,
			task_body_theirs_m: this.task_body_theirs
		}
	},
	methods: {
        saveMyVersion() {
            this.$emit('saveMyVersion', this.task_body_my_m)
        },
	}
}
</script>

<style scoped lang="scss">

</style>
